export default "__VITE_ASSET__7c34d0a9__"